import { Text } from '@cinch-labs/design-system'
import { useCarReviewsHubTracking } from '@cinch-nx/data-tracking'
import { useEffect } from 'react'

import NoReviewsImage from './no-reviews-image.svg'
import styles from './no-reviews.module.css'

export interface NoReviewsProps {
  selectedMake?: string | null
  selectedModel?: string | null
}

export const NoReviews = ({ selectedMake, selectedModel }: NoReviewsProps) => {
  const { trackNoResultsFound } = useCarReviewsHubTracking()

  useEffect(() => {
    if (!!selectedMake || !!selectedModel) {
      trackNoResultsFound(
        `${selectedMake} ${selectedModel ? selectedModel : ''}`.trim(),
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMake, selectedModel])

  return (
    <section className={styles.container} data-testid="no-reviews">
      <NoReviewsImage className={styles.icon} />
      <Text element="h2" fontWeight="bold" className={styles.header}>
        No results found
      </Text>
      <Text className={styles.body}>
        Sorry, we don’t have any reviews matching that. Please try some
        different filters.
      </Text>
    </section>
  )
}
